export default __webpack_public_path__ + "static/media/single-project-page-02-img3.4ff888cd.jpg";